import PropTypes from 'prop-types';
import React from 'react';
import { getComponentClasses } from '@99designs/utils/app';

export default class Spinner extends React.Component {
    render() {
        var classes = getComponentClasses('spinner', this.props.variations);

        return (<div className={classes} />);
    }
}

Spinner.propTypes = {
    variations: PropTypes.array
};



// WEBPACK FOOTER //
// ./~/@99designs/react-components/components/Spinner.jsx